<template>
  <li class="mdl-list__item mdl-list__item--two-line recipe-list-item">
    <i class="mdl-list__item-avatar" v-if="item.image" v-bind:style="{ backgroundImage: 'url(' + itemImage + ')', backgroundSize: 'cover' }"><span v-bind:style="{ width: '40px', height: '40px', display: 'block' }"></span></i>
    <span class="mdl-list__item-primary-content" v-bind:class="{ indent: hasNoImage }">
      <span><router-link :to="'/recipes/' + itemKey">{{ item.name }}</router-link></span>
      <span class="mdl-list__item-sub-title">
        <slot></slot>
      </span>
    </span>
    <span class="mdl-list__item-secondary-content">
      <!-- <span class="mdl-list__item-secondary-info">Actor</span> -->
      <!-- <a class="mdl-list__item-secondary-action" href="#"><i class="material-icons">star</i></a> -->
    </span>
  </li>
</template>

<script>
export default {
  name: 'recipe-list-item',
  props: [
    'item',
    'itemKey'
  ],
  data () {
    return {
      hasNoImage: !this.item.image
    }
  },
  computed: {
    itemImage () {
      return this.item.image
    }
  }
}
</script>

<style lang="sass">
.mdl-list__item-primary-content > span
  font-family: 'Scope One', serif
.mdl-list__item
  align-items: inherit
  padding-top: 0
.mdl-list__item--two-line
  height: auto
  .mdl-list__item-primary-content
    height: auto
.mdl-list__item-avatar, .mdl-list__item-avatar.material-icons
  margin-right: 16px
  margin-top: 4px
.mdl-list__item:last-child
  margin-bottom: 0
.mdl-list__item-avatar
  border-radius: inherit
.mdl-list__item-primary-content.indent
  margin-left: 56px
</style>



// WEBPACK FOOTER //
// src/components/RecipeListItem.vue